import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/katalog", label: "Katalog" },
  { to: "/katalog?category=kola", label: "Alu kola" },
  { to: "/katalog?category=kusovky", label: "Kusovky" },
  { to: "/katalog?category=pneu", label: "Pneumatiky" },
  { to: "/katalog?category=poklicky", label: "Pokličky" },
  { to: "/katalog?category=dily", label: "Autodíly" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-0 group">
          <span className="font-display text-2xl md:text-3xl leading-none tracking-tight">
            ALUKOLA
          </span>
          <span className="text-[#ff3b30] font-display text-2xl md:text-3xl leading-none">
            -BAZAR
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label}`}
              className="font-head text-sm uppercase tracking-[0.15em] text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+420777181818"
            data-testid="nav-phone"
            className="hidden md:flex items-center gap-2 font-head text-sm text-white/80 hover:text-[#ff3b30] transition-colors"
          >
            <Phone size={15} /> +420 777 181 818
          </a>
          <button
            data-testid="nav-cta"
            onClick={() => navigate("/kontakt")}
            className="hidden sm:inline-flex font-head text-sm uppercase tracking-wider bg-[#ff3b30] text-white px-5 py-2.5 hover:bg-white hover:text-black transition-colors duration-300"
          >
            Poptávka
          </button>
          {user && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="hidden sm:inline-flex font-head text-sm uppercase tracking-wider border border-white/20 px-4 py-2.5 hover:border-white transition-colors"
            >
              Admin
            </Link>
          )}
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-5 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link key={l.label} to={l.to} className="font-head text-lg uppercase tracking-wide text-white/80">
              {l.label}
            </Link>
          ))}
          {user && <Link to="/admin" className="font-head text-lg uppercase text-[#ff3b30]">Admin</Link>}
        </div>
      )}
    </header>
  );
}
